import api from "@/lib/axios";

export const vacancyStatusTemplateService = {
  // Get all vacancy status templates
  getAllTemplates: async () => {
    try {
      const response = await api.get("/vacancy-status-templates");
      return response.data;
    } catch (error) {
      throw new Error("Failed to fetch vacancy status templates: " + error.message);
    }
  },

  // Get a specific template by ID
  getTemplateById: async (templateId) => {
    try {
      const response = await api.get(`/vacancy-status-templates/${templateId}`);
      return response.data;
    } catch (error) {
      throw new Error("Failed to fetch vacancy status template: " + error.message);
    }
  },

  // Create a new vacancy status template
  createTemplate: async (templateData) => {
    try {
      const response = await api.post("/vacancy-status-templates", templateData);
      return response.data;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error("Failed to create vacancy status template: " + error.message);
    }
  },

  // Update a vacancy status template
  updateTemplate: async (templateId, templateData) => {
    try {
      const response = await api.put(`/vacancy-status-templates/${templateId}`, templateData);
      return response.data;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error("Failed to update vacancy status template: " + error.message);
    }
  },

  // Delete a vacancy status template
  deleteTemplate: async (templateId) => {
    try {
      const response = await api.delete(`/vacancy-status-templates/${templateId}`);
      return response.data;
    } catch (error) {
      throw new Error("Failed to delete vacancy status template: " + error.message);
    }
  },
};

